<template>
  <div>
    <v-card elevation="1">
      <v-card-text>
        <h4>Presentaciones para {{ productoData.Nombre }}</h4>
        <v-divider />
        <v-row class="mt-2">
          <v-col md="4">
            <v-form ref="formPresentacion">
              <v-text-field
              :rules="rules.Requerido"
            v-model="presentacion.nom"
            label="Nombre">

            </v-text-field>
            <v-text-field
            v-model="presentacion.cbr"
            label="Codigo de barras (Opcional)">

            </v-text-field>
            <v-text-field
            v-model="presentacion.cvi"
            label="Identificador (Opcional)">
            </v-text-field>
            <v-autocomplete
              v-model="presentacion.pvd"
              :rules="rules.Requerido"
              label="Proveedor"
              :items="Proveedores"
              item-text="Nombre"
              item-value="id"
              dense
            >
            </v-autocomplete>
            <v-text-field
            v-model="presentacion.rdm"
            :rules="rules.Requerido"
            @keypress="$pgsHelper.onlyNumber($event, presentacion.rdm)"
            :label="'Rendimiento ('+ ((productoData.Extra.AYB)?productoData.Extra.AYB.UM:'')+')' ">

            </v-text-field>
            <v-btn v-if="!presentacion.Id"  block color="blue" outlined dark @click="checkForm()">
              Agregar +
            </v-btn>
            <v-btn v-if="presentacion.Id" block color="blue" outlined dark @click="updatePrecentacion()">
              Guardar Edición
            </v-btn>
            <v-btn v-if="presentacion.Id" block color="red" outlined dark @click="cleanForm()">
              Cancelar Edicion
            </v-btn>
            </v-form>
          </v-col>
          <v-col md="8">
            <h3>Presentaciones</h3>
            <v-list v-if="presentaciones.length > 0">
              <template v-for="(pres, index) in presentaciones">
                <v-list-item :key="index">
                  <v-row>
                    <v-col md="8">
                      <h4>{{
                        pres.nom
                      }} <v-icon @click="editPresentacion(pres)" color="blue"> mdi mdi-pencil</v-icon><v-icon @click="deletePresentacion(pres)" color="red"> mdi mdi-delete</v-icon></h4>
                      {{getProovedorData(pres.pvd)}}
                      <p>
                        Rendimiento:
                        {{
                          pres.rdm
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider :key="index + 'i'"></v-divider>
              </template>
            </v-list>
            <v-alert
              v-if="presentaciones.length == 0"
              border="bottom"
              colored-border
              type="info"
              elevation="2"
            >
              El producto no cuenta con presentaciones.
            </v-alert>
          </v-col>

        </v-row>
        <v-divider />
        <div class="text-right">
          <v-btn @click="$emit('toggle', false)">Cerrar</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Producto from "../../../clases/Producto.js";
import PresentacionesAYB from "../../../clases/Restaurante/PresentacionesAYB.js";
import { mapGetters } from "vuex";
export default {
  name: "ProductosModificadores",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      productoData: Producto.getPropertyModel(),
      presentacion: PresentacionesAYB.getPropertyModel(),
      presentaciones:[],
      rules:PresentacionesAYB.getRules(),
      Proveedores:[],
      dataEditPres:null,
    };
  },
  methods: {
    getProovedorData(id){
      let prov = this.$pgsHelper.getById(this.Proveedores,"id",id)
      if(prov){
        return prov.Nombre
      }
      
    },
    async editPresentacion(presentacion){
      let data =  this.$pgsHelper.cloneObj(presentacion)
      this.presentacion = new PresentacionesAYB(data)
      this.dataEditPres = data;
    },
    deletePresentacion(presentacion){
      let datos = {id:presentacion.Id}
      this.$alert.alertConfirm({
          action: "eliminar",
          obj: "la presentacion de producto",
          route: "AMC-Presentaciones-deletePresentacion",
          data:  datos,
          onSuccess: () => {
            this.getPresentacionesByProduct()
          },
        });
    },
    async cleanForm(){
      this.presentacion = new PresentacionesAYB()
    },
    checkForm: function (e) {
      if (this.$refs.formPresentacion.validate()) {
        this.presentacion.prd = this.productoData.Id
        this.presentacion.rdm = Number( this.presentacion.rdm)
        let datos = this.presentacion
        this.$alert.alertConfirm({
          action: "agregar",
          obj: "la presentacion de producto",
          route: "AMC-Presentaciones-createPresentaciones",
          data:  datos,
          onSuccess: () => {
            this.getPresentacionesByProduct()
          },
        });
      }
    },
    async updatePrecentacion(){
       if (this.$refs.formPresentacion.validate()) {
        this.presentacion.prd = this.productoData.Id
        this.presentacion.rdm = Number( this.presentacion.rdm)
        let datos = this.presentacion
        datos.id = this.presentacion.Id
        this.$alert.alertConfirm({
          action: "editar",
          obj: "la presentacion de producto",
          route: "AMC-Presentaciones-updatePresentaciones",
          data:  datos,
          onSuccess: () => {
            this.getPresentacionesByProduct()
            this.cleanForm()
          },
        });
      }
    },
    async getPresentacionesByProduct(){
      let data = await PresentacionesAYB.getPresentacionByProd(this.productoData.Id)
      this.presentaciones =data
    },
    async getProveedores() {

        let proveedorArray = [];
        const database = await this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("AMC/Provedores", [
        ]);
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          arrayFactura.forEach((element) => {
            proveedorArray.push({
              id: element[0],
              Nombre: element[1]["nom"],
            });
          });
          this.Proveedores = proveedorArray
        }

    },
  },
  computed: {
    ...mapGetters("dataLists", ["getModificadores"]),
    modificadoresByDepartamento() {
      let modificador = [];
      this.getModificadores.forEach((modi) => {
        if (this.productoData.Departamentos) {
          if (this.productoData.Departamentos.includes(modi.Departamento)) {
            modificador.push(modi);
          }
        }
      });
      return modificador;
    },
    origenes() {
      let ori = this.$store.getters.getCentrosConsumo;
      return ori;
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    this.getProveedores();
    if (this.edit) {
      this.productoData = new Producto(this.dataEdit);
    } else {
      this.productoData = new Producto();
      
    }
    this.presentacion = new PresentacionesAYB();
    this.getPresentacionesByProduct()
  },
};
</script>